import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loading: false,
  contacts: [],
  total: 0,
  error: null,
};

const route = "modules/workOrders/views/main/components/contactTab/redux/slice.";

const workOrdersSearchContacts = createAsyncThunk(
  "workOrders/trackerTab/workOrdersSearchContacts",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        workOrdersSearchContacts.query,
        {
          conditions,
          sort,
          limit,
          offset: offset > -1 ? offset : 0,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchCustomerLocations");
      return rejectWithValue(exc);
    }
  }
);

workOrdersSearchContacts.query = `
    query ($conditions: [EntityContactSearchInput], $sort: [EntityContactSortInput], $limit: Int, $offset: Int) {
        data: searchEntityContacts(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
                entityId
                name
                phone
                email
                notifyByPhone
                notifyByEmail
                countryCode
                createdOn
            }
        }
    }
`;

export { workOrdersSearchContacts };

//Slice
const workOrdersContactTabRedux = createSlice({
  name: "workOrders/contactTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //workOrdersSearchContacts
    builder.addCase(workOrdersSearchContacts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrdersSearchContacts.fulfilled, (state, action) => {
      state.loading = false;
      state.contacts = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(workOrdersSearchContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersContactTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
